{
  "components": {
    "AcceptanceFilters": {
      "deduplicated": "Deduplicated",
      "only_includes_the_final_outcome_of": "Only includes the final outcome of failed payments that are\n                  retried.",
      "raw": "Raw",
      "includes_all_payment_attempts_shows_repeat": "Includes all payment attempts. Shows repeat attempts to\n                  complete a payment.",
      "payment_success_rate": "Payment success rate",
      "includes_attempted_payments_blocked_payments_and": "Includes attempted payments, blocked payments, and failed\n                  authentication.",
      "authorization_rate": "Authorization rate",
      "excludes_blocked_payments_and_failed_authentications": "Excludes blocked payments and failed authentications.",
      "payment_method_category": "Payment method category",
      "attrs": {
        "filter_by_category": "Filter by: Category",
        "filter_by_payment_method": "Filter by: Payment method",
        "filter_by_funding_source": "Filter by: Funding source",
        "filter_by_card_type": "Filter by: Card type",
        "filter_by_card_country": "Filter by: card country",
        "filter_by_card_brand": "Filter by: Card brand",
        "filter_by_interaction_type": "Filter by: Interaction type",
        "filter_by_input_method": "Filter by: Input method",
        "filter_by_currency": "Filter by: Currency",
        "filter_by_network_token_status": "Filter by: Network token status",
        "filter_by_retry_status": "Filter by: Retry status",
        "filter_by_postal_code_response": "Filter by: Postal code response",
        "filter_by_cvc_response": "Filter by: CVC response",
        "filter_by_3ds_outcome": "Filter by: 3DS outcome"
      },
      "payment_method": "Payment method",
      "funding_source_type": "Funding source type",
      "card_type": "Card type",
      "card_country": "Card country",
      "card_brand": "Card brand",
      "interaction_type": "Interaction type",
      "more_filters": "More filters"
    },
    "content": {
      "apply": "Apply",
      "attrs": {
        "search": "Search"
      }
    },
    "AcceptanceTab": {
      "attrs": {
        "key_metrics": "Key metrics"
      }
    },
    "CardPaymentsBreakdown": {
      "card_payments_breakdown": "Card payments breakdown",
      "analyze_card_authorization_success_and_the": "Analyze card authorization success, and the impact on payment\n            volume. Includes issuer declined payments.",
      "download": "Download",
      "pivot_by": "Pivot by",
      "payment_volume": "Payment volume",
      "payments": "Payments",
      "share_of_payments": "Share of payments",
      "updated_yesterday": "Updated yesterday",
      "success_rate": "Success rate"
    },
    "FailedCardPayments": {
      "failed_card_payments": "Failed card payments",
      "find_out_why_card_payments_failed": "Find out why card payments failed.",
      "learn_more_about_decline_codes": "Learn more about decline codes",
      "failed_volume": "Failed volume",
      "failed": "Failed",
      "share_of_failures": "Share of failures",
      "failure_rate": "Failure rate",
      "reason": "Reason",
      "failed_count": "Failed count",
      "total": "Total",
      "usd_285k": "MYR 285K"
    },
    "BlockedCardPayments": {
      "blocked_card_payments": "Blocked card payments",
      "find_out_why_some_card_payments": "Find out why some card payments were blocked.",
      "no_payments_matching_this_selection": "No payments matching this selection.",
      "clear_filters_or_select_another_date": "Clear filters or select another date range and try again."
    },
    "AddChartModal": {
      "add_charts": "Add charts",
      "cancel": "Cancel"
    },
    "AnalyticsFilters": {
      "clear_all_filters": "Clear all filters"
    },
    "ChartDataToggle": {
      "chart": "Chart",
      "data": "Data"
    },
    "PaymentVolumeWidget": {
      "attrs": {
        "payment_volume": "Payment Volume"
      },
      "current_period": "Current Period",
      "previous_period": "Previous Period",
      "daily_average": "Daily Average",
      "usd_156000k": "MYR 15,600.0K",
      "monthly_growth": "Monthly Growth",
      "yoy_growth": "YoY Growth",
      "transaction_growth": "Transaction Growth",
      "date": "Date",
      "volume": "Volume",
      "usd": "MYR"
    },
    "TransactionCountWidget": {
      "attrs": {
        "number_of_transactions": "Number of Transactions"
      },
      "transactions": "Transactions"
    },
    "AverageTransactionWidget": {
      "attrs": {
        "average_transaction": "Average Transaction"
      }
    },
    "CardVolumeKPIs": {
      "attrs": {
        "card_volume": "Card Volume"
      }
    },
    "PaymentMethodsWidget": {
      "attrs": {
        "payment_methods": "Payment Methods"
      },
      "method": "Method",
      "share": "Share"
    },
    "PaymentConversionWidget": {
      "attrs": {
        "payment_conversion": "Payment Conversion"
      },
      "conversion_rate": "Conversion rate:"
    },
    "AttemptsPerPaymentWidget": {
      "attrs": {
        "attempts_per_payment": "Attempts Per Payment"
      },
      "payments": "payments",
      "total_payments": "Total payments:",
      "average_attempts": "Average attempts:"
    },
    "RefundAnalysisKPIs": {
      "refund_analysis": "Refund Analysis",
      "total_refunds": "Total Refunds",
      "usd_36027k": "MYR 3,602.7K",
      "refund_count": "Refund Count",
      "refund_rate": "Refund Rate",
      "avg_refund": "Avg Refund",
      "usd_2573366": "MYR 25,733.66"
    },
    "RefundVolumeWidget": {
      "attrs": {
        "refund_volume": "Refund Volume"
      },
      "refund_amount": "Refund Amount"
    },
    "RefundReasonsWidget": {
      "attrs": {
        "refund_reasons": "Refund Reasons"
      }
    },
    "PaymentGeographyWidget": {
      "attrs": {
        "payment_geography": "Payment Geography"
      },
      "map": "Map"
    },
    "CardBrandsDistributionWidget": {
      "attrs": {
        "card_brands": "Card Brands"
      },
      "brand": "Brand"
    },
    "CardSuccessRateWidget": {
      "attrs": {
        "card_success_rate": "Card Success Rate"
      }
    },
    "DeclineReasonsWidget": {
      "attrs": {
        "common_decline_reasons": "Common Decline Reasons"
      },
      "code": "Code",
      "description": "Description"
    },
    "AnalyticsSection": {
      "total_volume": "Total Volume",
      "avg_transaction": "Avg Transaction",
      "conversion": "Conversion"
    },
    "AttentionNeededWidget": {
      "attention_needed": "Attention needed",
      "urgent": "urgent",
      "urgent_2": "Urgent",
      "items_require_your_attention": "items require your attention",
      "view_all_items": "View all items"
    },
    "AuthenticationTab": {
      "compared_to": "Compared to",
      "previous_period": "Previous period",
      "clear_filters": "Clear filters",
      "or_select_another_date_range_and": "or select another date range and try again.",
      "3d_secure_authentication_outcomes": "3D Secure authentication outcomes",
      "3d_secure_authentication_request_reasons": "3D Secure authentication request reasons"
    },
    "BalanceSnapshotWidget": {
      "available_balance": "Available balance",
      "view_all": "View all",
      "updated_on": "Updated on",
      "upcoming_payout": "Upcoming payout ·",
      "view_payout_details": "View payout details"
    },
    "BreakdownTable": {
      "category": "Category",
      "share_of_volume": "Share of volume",
      "change": "Change"
    },
    "CardBrandsTable": {
      "card_brand": "Card Brand",
      "avg_amount": "Avg. Amount",
      "rs": "Rs."
    },
    "CardErrorCodes": {
      "count": "Count"
    },
    "CompanySelector": {
      "attrs": {
        "search_companies": "Search companies..."
      },
      "no_companies_found": "No companies found"
    },
    "ComparisonSelector": {
      "compare": "Compare",
      "start": "Start",
      "attrs": {
        "mm_dd_yyyy": "MM / DD / YYYY"
      },
      "end": "End",
      "clear": "Clear"
    },
    "DisputesFilters": {
      "show_rates_based_on": "Show rates based on",
      "dispute_date": "Dispute date",
      "calculate_rates_based_on_the_date": "Calculate rates based on the date a dispute was received.",
      "payment_date": "Payment date",
      "calculate_rates_based_on_the_date_2": "Calculate rates based on the date the original payment was\n                    made.",
      "payment_count": "Payment count",
      "calculate_rates_based_on_the_number": "Calculate rates based on the number of payments.",
      "calculate_rates_based_on_revenue_also": "Calculate rates based on revenue, also known as payment\n                    volume.",
      "include_early_fraud_warnings_efw": "Include early fraud warnings (EFW)",
      "dont_include_early_fraud_warnings_efw": "Don't include early fraud warnings (EFW)",
      "exclude_early_fraud_warnings_from_dispute": "Exclude early fraud warnings from dispute and fraud rate\n                    calculations.",
      "include_early_fraud_warnings_which_are": "Include early fraud warnings, which are alerts from card\n                    networks about potentially fraudulent payments, which may\n                    later escalate to disputes.",
      "attrs": {
        "filter_by_payment_country": "Filter by: Payment country"
      }
    },
    "DisputesTab": {
      "key_metrics_for_cards": "Key metrics for cards",
      "card_disputes_breakdown": "Card disputes breakdown",
      "monthly_submission_performance": "Monthly submission performance",
      "a_detailed_view_of_submission_performance": "A detailed view of submission performance metrics and trends over\n              the past 12 months.",
      "all_reasons": "All reasons",
      "monthly_dispute_outcomes": "Monthly dispute outcomes",
      "a_breakdown_of_how_card_disputes": "A breakdown of how card disputes were resolved over the past 12\n              months."
    },
    "DownloadReportModal": {
      "download_report": "Download report —",
      "report_format": "Report format",
      "itemized": "Itemized",
      "summary": "Summary",
      "columns": "Columns",
      "all": "All (",
      "show": "Show",
      "hide": "Hide",
      "attrs": {
        "filter_by_name_or_metadata_key": "Filter by name or metadata key"
      },
      "notifications": "Notifications",
      "email_simonverraestceylonteacom_when_your_report_is": "Email simon.verraest@ceylontea.com when your report is ready to\n                download",
      "the_file_will_be_saved_as": "The file will be saved as .csv."
    },
    "FeedbackModal": {
      "share_feedback": "Share feedback",
      "attrs": {
        "let_us_know_what_you_think": "Let us know what you think, and what other features you'd like to see."
      },
      "have_a_specific_issue": "Have a specific issue?",
      "contact_support": "Contact support",
      "or": "or",
      "read_our_docs": "read our docs",
      "send_feedback": "Send feedback"
    },
    "GeoPaymentMap": {
      "loading_map_data": "Loading map data..."
    },
    "KeyMetricsSection": {
      "current_period": "Current period"
    },
    "ListWidget": {
      "view_more": "View more"
    },
    "MetricChart": {
      "previous_period": "previous period",
      "prev": "(prev)"
    },
    "PaymentMethodFilter": {
      "select_all": "Select all",
      "clear_all": "Clear all"
    },
    "PaymentMethodsFilters": {
      "input_method": "Input method",
      "network_token_status": "Network token status"
    },
    "PaymentMethodsTab": {
      "payment_methods_overview": "Payment methods overview",
      "share_of_count": "Share of count",
      "avg_order_value": "Avg order value",
      "top_countries": "Top countries",
      "country": "Country"
    },
    "RecommendationsWidget": {
      "recommendations": "Recommendations",
      "personalized": "Personalized",
      "impact": "impact",
      "suggestions_for_you": "suggestions for you",
      "view_all_recommendations": "View all recommendations"
    },
    "RefundsTab": {
      "refunds_overview": "Refunds overview",
      "refund_count": "Refund count",
      "refund_rate": "Refund rate"
    },
    "ResourcesSidebar": {
      "resources": "Resources",
      "view_other_payment_reports": "View other payment reports"
    }
  },
  "pages": {
    "CardMonitoringPrograms": {
      "card_monitoring_programs": "Card monitoring programs",
      "card_networks_require_that_you_keep": "Card networks require that you keep dispute and fraud at acceptable\n        levels. If your business exceeds the limits dictated by the networks\n        (e.g., Visa or Mastercard) you're placed into one of their monitoring\n        programs.",
      "learn_more": "Learn more",
      "visa_acquirer_monitoring_program_vamp": "Visa Acquirer Monitoring Program (VAMP)",
      "in_good_standing": "In good standing"
    },
    "CustomMetrics": {
      "check_daily": "Check daily",
      "see_all": "See all",
      "shared": "Shared",
      "trial_conversion_rate": "Trial conversion rate",
      "high": "High",
      "new_customers": "New customers",
      "create_a_new_group": "Create a new group",
      "name": "Name",
      "add_reports": "Add reports",
      "monitor_your_data_with_custom_metrics": "Monitor your data with custom metrics",
      "create_custom_metrics_with_nadi_to": "Create custom metrics with Nadi to get quick answers to complex data\n          questions. Organize and monitor them in one place.",
      "go_to_nadi": "Go to Nadi",
      "track_key_metrics": "Track key metrics",
      "monitor_your_most_important_business_metrics": "Monitor your most important business metrics in real-time with\n            custom dashboards.",
      "share_insights": "Share insights",
      "collaborate_with_your_team_by_sharing": "Collaborate with your team by sharing custom metric groups and\n            reports.",
      "easy_to_create": "Easy to create",
      "build_custom_metrics_with_an_intuitive": "Build custom metrics with an intuitive interface - no SQL knowledge\n            required."
    },
    "Nadi": {
      "basic_reports": "Basic Reports",
      "daily_activity": "Daily activity",
      "sales_refunds_adjustments_and_disputes": "Sales, refunds, adjustments, and disputes",
      "daily_balance": "Daily balance",
      "account_balance_and_activity_summary": "Account balance and activity summary",
      "monthly_summary_and_balance": "Monthly summary and balance",
      "sales_refunds_gross_and_net_activity": "Sales, refunds, gross, and net activity",
      "gross_volume": "Gross Volume",
      "gross_volume_query_used_to_match": "Gross volume query - used to match home chart Gross Volume",
      "failed_payments": "Failed Payments",
      "failed_payments_sorted_by_descending_order": "Failed payments sorted by descending order of time",
      "new_customers": "New Customers",
      "monthly_count_of_new_customers": "Monthly count of new customers",
      "payments_payouts_and_transfers": "Payments, Payouts and Transfers",
      "gross_charge_volume_by_month": "Gross charge volume by month",
      "total_processing_volume_for_each_currency": "Total processing volume for each currency per month",
      "payment_card_breakdown": "Payment card breakdown",
      "charges_and_amounts_for_each_card": "Charges and amounts for each card brand and type by currency",
      "payments_info_breakdown": "Payments info breakdown",
      "summary_of_address_info_submitted_with": "Summary of address info submitted with charges",
      "untitled_report": "Untitled report",
      "reports": "Reports",
      "schema": "Schema",
      "templates": "Templates",
      "generate": "Generate",
      "ask_nadi_assistant": "Ask Nadi Assistant",
      "ex_get_me_all_connected_accounts": "(ex: get me all connected accounts with transactions this month)",
      "a_nadi_plan_is_required_to": "A nadi plan is required to use this feature.",
      "we_have_already_been_notified_of": "We have already been notified of the problem, but please don't\n              hesitate to contact us if you have any questions.",
      "custom_reporting_with_an_ai_assistant": "Custom reporting with an AI assistant",
      "gross_volume_2": "Gross volume",
      "edit": "Edit",
      "show_recurring_payments_under_usd_24": "Show recurring payments under MYR 24",
      "get_quick_answers_to_complex_data": "Get quick answers to complex data questions with the AI\n                    assistant. Use natural language to create and edit custom\n                    reports—no need to learn SQL.",
      "try_it_free_until_january_4": "Try it free until January 4, 2026, then starting at",
      "usd_50month": "MYR 50/month",
      "plus_a": ", plus a",
      "per_charge_fee": "per charge fee",
      "by_clicking_start_free_trial_you": "By clicking \"Start free trial\", you enroll in an\n                    automatically renewing subscription. You authorize\n                    CIMB to debit all fees from your CIMB\n                    Balance after your free trial ends. Cancel anytime in your",
      "settings": "settings",
      "start_free_trial": "Start free trial →"
    },
    "renderChart": {
      "attrs": {
        "successful_payments": "Successful payments",
        "net_volume": "Net volume",
        "refunds_volume": "Refunds volume",
        "total_payments": "Total payments",
        "dispute_count": "Dispute count",
        "dispute_activity": "Dispute activity",
        "disputed_payments": "Disputed payments",
        "failed_payments": "Failed payments",
        "spend_per_customer": "Spend per customer",
        "top_customers_by_spend": "Top customers by spend",
        "top_countries_by_spend": "Top countries by spend",
        "blocked_payments": "Blocked payments",
        "blocked_payments_volume": "Blocked payments volume"
      },
      "top_payment_method_categories": "Top payment method categories",
      "card": "Card",
      "usd_24090k": "MYR 240.90K",
      "bank_transfer": "Bank transfer",
      "usd_18050k": "MYR 180.50K",
      "ewallet": "E-wallet",
      "usd_9520k": "MYR 95.20K",
      "crypto": "Crypto",
      "usd_1230k": "MYR 12.30K",
      "other": "Other",
      "usd_510k": "MYR 5.10K"
    },
    "Overview": {
      "current_snapshot": "Current snapshot",
      "overview": "Overview",
      "add": "Add",
      "done": "Done",
      "drag_to_reorder": "Drag charts to reorder, or remove them with ×. Select Done when you're finished."
    },
    "PaymentAnalytics": {
      "payment_analytics": "Payment analytics"
    },
    "VampDetail": {
      "view_your_monitoring_program_status_and": "View your monitoring program status and history.",
      "history": "History",
      "your_program_history_for_the_last": "Your program history for the last 12 months.",
      "program_type": "Program type",
      "fraud_and_disputes": "Fraud and disputes",
      "measures_fraud_and_disputes_against_the": "Measures fraud and disputes against the total number\n                          of settled payments",
      "card_testing": "Card testing",
      "measures_card_testing_against_the_total": "Measures card testing against the total number of\n                          settled payments",
      "historical_and_current_program_status": "Historical and current program status",
      "visaidentified_fraud_and_disputes_against_the": "Visa-identified fraud and disputes against the total number of settled\n          payments",
      "no_past_history_found": "No past history found.",
      "estimated_program_status": "Estimated program status",
      "pomelos_estimate_of_your_visa_frauds": "CIMB' estimate of your Visa frauds and disputes. Aim to keep your\n          VAMP ratio under 0.5%.",
      "about_how_to_keep_your_disputes": "about how to keep your disputes and fraud low.",
      "program_overview": "Program overview",
      "preventing_fraud_and_disputes": "Preventing fraud and disputes",
      "preventing_card_testing": "Preventing card testing"
    }
  }
}
